<script>
	module.exports = {};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';
	@import 'mixins/flexbox';

	.family-bok {
		.button {
			padding: 2rem;
			font-size: 1.5rem;
		}

		.templates {
			display: flex;
			align-items: center;

			> * {
				text-align: center;
				flex: 2;
			}

			.spacer {
				flex: 1;
			}
		}
	}
</style>
<template>
	<main
		id="content"
		class="main family-bok">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">Family Book of Knowledge</h1>
			</div>
		</header>
		<div class="main-content wrapper">
			<section>
				<h3>Record the interesting knowledge you're learning this summer in a family notebook or online.</h3>
				<h3>Then you can watch all of the amazing knowledge you learn together build over the summer!</h3>
				<h3>To print it out, download the templates below:</h3>
				<div class="templates">
					<a
						href="https://about.readworks.org/uploads/7/9/6/7/79679564/family_book_of_knowledge_writing.docx"
						class="button"
						>Template for Writing</a
					>
					<span class="spacer"></span>
					<a
						href="https://about.readworks.org/uploads/7/9/6/7/79679564/family_book_of_knowledge_drawing.docx"
						class="button"
						>Template for Drawing</a
					>
				</div>
				<h3>To do it digitally, make sure you do the Article-A-Day at Home Digital Training.</h3>
				<div class="learn text-centered">
					<a
						href="/article-a-day-at-home-digital"
						class="button"
						>Learn How to do Article-A-Day at Home Digitally</a
					>
				</div>
			</section>
		</div>
	</main>
</template>
